<script setup lang="ts">
const colorMode = useColorMode();
const { user } = useOidcAuth();
const logoSrc = computed(() => `/logo-${colorMode.value}.svg`);

const orgId = user.value?.userInfo?.org_id as string;
const userCanManageBilling =
  !orgId || (await allows(manageOrganizations, orgId));

const showBuyCreditButton = computed(
  () =>
    !user.value?.userInfo?.customerId &&
    !user.value?.userInfo?.isEnterpriseAccount &&
    userCanManageBilling,
);

const { isErrorPage = false } = defineProps<{
  isErrorPage?: boolean;
}>();
</script>

<template>
  <div>
    <header
      class="flex bg-(--ui-bg) shrink-0 justify-between items-center py-4 px-6 h-header border-b border-b-(--ui-border-accented)"
    >
      <div class="flex flex-row">
        <NuxtLink
          href="/app/projects"
          class="cursor-pointer text-3xl font-black"
          data-ph-capture-attribute-id="topbar:access-icon_click"
        >
          <div class="h-10">
            <ClientOnly>
              <NuxtImg class="h-full" :src="logoSrc" />
              <template #fallback>
                <NuxtImg class="h-full" src="/logo-system.svg" />
              </template>
            </ClientOnly>
          </div>
        </NuxtLink>
        <div id="teleport-toolbar" />
      </div>
      <div v-if="!isErrorPage" class="flex flex-row items-center gap-x-3">
        <BuyCreditButton
          v-if="showBuyCreditButton"
          variant="soft"
          data-ph-capture-attribute-id="topbar:buy-credit-button_click"
        />
        <UserProfileMenu />
      </div>
    </header>
    <div class="p-3">
      <slot />
    </div>
  </div>
</template>

<style>
.h-header {
  height: 4.5rem;
}

.h-page {
  height: calc(100vh - (var(--spacing) * 18));
}

.w-page {
  width: calc(100vw - 1.5rem);
}
</style>
